import { filterMarkets, filterOutrightsMarkets, prepareOutrightMarkets } from "../../helpers";
export const prepareMarkets = (pointsFormatter, markets, cardConfig, specialLeagues, allEvents, outrightSelectionSorter, marketTemplateMap) => {
    // 1. Filter outrights
    const outrightsMarkets = prepareOutrightMarkets(markets, allEvents, outrightSelectionSorter);
    // 2. Group markets by sport and store them in an object
    const regularMarkets = filterOutrightsMarkets(false, markets, allEvents);
    // 3. Fill empty selections for each sport
    const marketsBySport = filterMarkets(pointsFormatter, regularMarkets, cardConfig, specialLeagues, marketTemplateMap);
    return [...marketsBySport, ...outrightsMarkets];
};
//# sourceMappingURL=prepareMarkets.js.map